// Accounts API endpoints
//
// `clientId` est le code client CBS (`customerCode`), jamais le `businessKey` du Référentiel -
// c'est ce que le backend attend sur ces trois routes (voir docs/whatsappbanking côté backend).

export const getAccountsUrl = (clientId: string): string => {
  return `/customers/${clientId}/accounts`;
};

export const getAccountRibUrl = (clientId: string, accountNumber: string): string => {
  return `/customers/${clientId}/accounts/${accountNumber}/rib`;
};

export const getMiniStatementUrl = (
  clientId: string,
  accountNumber: string,
  limit?: number,
): string => {
  const base = `/customers/${clientId}/accounts/${accountNumber}/mini-statement`;
  return limit ? `${base}?limit=${limit}` : base;
};
